<h3>Restrição de CNAEs para Ecommerce e Link de Pagamento</h3>
<div fxLayout="row" fxLayoutAlign="left stretch">
  <div fxLayoutGap="20px" class="filter-container" *ngIf="hasWriteAccess">
    <div fxFlex="10" fxFlexAlign="center">
      <button class="fd-button" (click)="addCnae()">
        <div class="d-flex  justify-content-center">
          <fa-icon icon='plus-circle' size="1x"></fa-icon> Novo registro
        </div>
      </button>
    </div>
  </div>

  <div *ngIf="hasWriteAccess" fxFlex="17" fxFlexAlign="center">
    <button [disabled]="!hasContentList"
      [ngClass]="{ 'fd-button--disabled' : !hasContentList }" class="fd-button"
      (click)="downloadCnaeList()" matTooltip="Download da lista de CNAES">
      <div class="d-flex  justify-content-left">
        <fa-icon icon='user-lock' size="1x"></fa-icon> Exportar
      </div>
    </button>
    <div fxFlex="10" fxFlexAlign="center">
      <fa-icon class="fd-icon" icon='download' size="1x" (click)="downloadTemplate()"
        matTooltip="Download do modelo de arquivo"></fa-icon>
    </div>
  </div>
  <div *ngIf="hasWriteAccess" fxFlex="17" fxFlexAlign="center">
    <button class="fd-button"
      (click)="uploadCnaes()" matTooltip="Importar lista de CNAES">
      <div class="d-flex justify-content-center">
        <fa-icon icon='user-lock' size="1x"></fa-icon> Importar
      </div>
    </button>
  </div>
</div>

<form [formGroup]="formGroup">
  <div #uploadCnaeList>
    <ngx-mat-file-input *ngIf="hasWriteAccess" class="hiddenUpload"
    (change)="startUpload($event.target.files)" method="uploadCnaeList" name="upload-start" accept="*/*"></ngx-mat-file-input>
  </div>

  <div fxLayout="row" fxLayoutAlign="left stretch">
    <div fxLayoutGap="20px" class="filter-container">
      <div class="fd-proposal-search__filter-field">
        <fd-institution (institutionSelected)="changeSelectedInstitution($event)" [formGroup]="formGroup"
          [field]="fields.institution">
        </fd-institution>
      </div>
      <div class="fd-proposal-search__filter-field">
        <fd-service-contract [formGroup]="formGroup" [field]="fields.serviceContract"
          [institution]="selectedInstitution">
        </fd-service-contract>
      </div>
      <div fxFlex="10" fxFlexAlign="center">
        <fd-button mat-flat-button [content]="'Buscar'" (trigger)="search()"></fd-button>
      </div>
    </div>
  </div>
  <div class="fd-proposal-search__filter-field">
    <fd-input 
      [parentForm]="formGroup" 
      [field]="fields.cnaeFilter" 
      fxFlex=30 >
    </fd-input>
  </div>
</form>

<div class='list'>
  <app-list-whitelist-cnaes [dataSource]="dataSource" [totalItens]="totalItens" (deleteItem)="deleteCnae($event)"
    (changePage)="changePage($event)">
  </app-list-whitelist-cnaes>
</div>